import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import '@progress/kendo-theme-default/dist/all.css';
import './index.scss';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './riskwell/Store/store';
import '../node_modules/react-redux-toastr/lib/css/react-redux-toastr.min.css'; 

ReactDOM.render(
  <Provider store={store()}>
      {/* <NotificationSystem key="notificationSystem" ref= { (n) => toastr.setNotificationSystem(n)  } /> */}
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
